import { useAuthStore } from "@/stores/use-auth-store";

export const useAuth = useAuthStore;

